export default "__VITE_ASSET__82f02c9b__"